import { render, staticRenderFns } from "./ObjectAddUpdate.vue?vue&type=template&id=3ef93f3c"
import script from "./ObjectAddUpdate.vue?vue&type=script&lang=js"
export * from "./ObjectAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports